/**
 * Uygulama kabuğu: sabit kenar çubuğu + yapışkan üst şerit + içerik.
 *
 * Eski `Components/Navbar` yerine geçer. İki davranış BİLİNÇLİ olarak
 * korundu:
 *   - `/alarm2` tam ekran uyarı panosu; eski Navbar orada kendini gizliyordu,
 *     kabuk da gizleniyor.
 *   - Bazı sayfalar kendi dolgusunu yönetiyor (pano, alarm, yardım...);
 *     `noPaddingPages` listesi aynen taşındı.
 *
 * Kaydırma belge seviyesinde değil, içerik sütununda: `body` bu projede
 * `overflow: hidden; height: 100vh` ile kilitli.
 */
import { Drawer } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../Components/Shell/Sidebar";
import Topbar from "../Components/Shell/Topbar";

const COLLAPSE_KEY = "boyahane.sidebar.collapsed";

/** Kabuğun hiç çizilmediği tam ekran sayfalar. */
const CHROMELESS_PAGES = ["/alarm2"];

/** Kendi dolgusunu yöneten sayfalar. */
const NO_PADDING_PAGES = [
  "/alarm",
  "/alarm2",
  "/dashboard",
  "/pano",
  "/newDashboard",
  "/help-center",
  "/constraints",
  "/simulasyon",
];

/**
 * Sahadaki dokunmatik ekranlar: ekrana TAM sığmalı, altta ölü boşluk kalmamalı.
 * Diğer sayfalardaki `pb-20` bu ekranlarda tablonun altında 80px boşluk
 * bırakıyordu; burada dolgu ince tutulur ve kaydırma tablonun kendi içinde
 * kalır (sayfa değil).
 */
const TOUCH_PAGES = ["/asma", "/asma-spv", "/toplama"];

const HomeLayout = ({ children }) => {
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSE_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSE_KEY, collapsed ? "1" : "0");
    } catch {
      /* localStorage kapalıysa tercih yalnız bu oturumda geçerli olur */
    }
  }, [collapsed]);

  // Route değişince mobil çekmeceyi kapat.
  useEffect(() => setMobileNavOpen(false), [location.pathname]);

  const path = decodeURIComponent(location.pathname);
  const chromeless = CHROMELESS_PAGES.includes(path);
  const isTouch = TOUCH_PAGES.includes(path);
  const usePadding = !NO_PADDING_PAGES.includes(path);

  /* Dokunmatik ekranda kaydırma sayfada değil tabloda; boşluk bırakılmaz. */
  const mainClass = !usePadding
    ? "flex-1 overflow-auto"
    : isTouch
    ? "flex-1 min-h-0 overflow-hidden px-4 pb-3 pt-3"
    : "flex-1 overflow-auto px-5 pb-20 pt-4";

  if (chromeless) {
    return <div className="h-full w-full overflow-auto">{children}</div>;
  }

  return (
    <div
      className="flex h-full w-full overflow-hidden bg-surface-muted font-sans text-content"
      style={{ "--sidebar-w": collapsed ? "68px" : "260px" }}
    >
      {/* Masaüstü kenar çubuğu */}
      <div className="hidden w-[var(--sidebar-w)] shrink-0 transition-[width] duration-200 ease-out laptop:block">
        <Sidebar
          collapsed={collapsed}
          onToggle={() => setCollapsed((v) => !v)}
        />
      </div>

      {/* Mobil çekmece */}
      <Drawer
        placement="left"
        open={mobileNavOpen}
        onClose={() => setMobileNavOpen(false)}
        width={272}
        closable={false}
        styles={{ body: { padding: 0, background: "#0d111a" } }}
      >
        <Sidebar
          collapsed={false}
          showToggle={false}
          onNavigate={() => setMobileNavOpen(false)}
        />
      </Drawer>

      {/* İçerik sütunu */}
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Topbar onOpenMobileNav={() => setMobileNavOpen(true)} />
        <main className={mainClass}>{children}</main>
      </div>
    </div>
  );
};

export default HomeLayout;
